"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function NewPromotions(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "allPromotionContentWrapper"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "bannerImageOfPromotion",
    href: props.promotionalContent.webLink,
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      width: "100%"
    },
    src: props.promotionalContent.imageLink
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "promotionContentTextWrapper"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "promotionContentText promotionContentTextMargin"
  }, props.promotionalContent.content), /*#__PURE__*/_react["default"].createElement("a", {
    href: props.promotionalContent.webLink,
    target: "_blank",
    className: "promotionContentText promotionOpenNow",
    style: {
      textDecoration: 'underline',
      display: 'inline-block'
    }
  }, props.i18next.t("lable.openNow"))));
}
var _default = NewPromotions;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/NewPromotions.js
 ** module id = 2390
 ** module chunks = 0
 **/